var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvaPhase4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 763.49 427.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-IVA-P4 {\n        fill: #1a3378;\n        stroke: #1a3378;\n      }\n\n      .cls-2-IVA-P4 {\n        stroke-width: .05px;\n      }\n\n      .cls-2-IVA-P4, .cls-3-IVA-P4, .cls-4-IVA-P4 {\n        fill: #fcce14;\n      }\n\n      .cls-2-IVA-P4, .cls-4-IVA-P4, .cls-5-IVA-P4, .cls-6-IVA-P4 {\n        stroke: #fcce14;\n      }\n\n      .cls-3-IVA-P4, .cls-7-IVA-P4, .cls-8-IVA-P4, .cls-9-IVA-P4, .cls-10-IVA-P4 {\n        stroke-width: 0px;\n      }\n\n      .cls-11-IVA-P4 {\n        fill: rgba(255, 255, 255, 0);\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-7-IVA-P4 {\n        fill: #333;\n      }\n\n      .cls-8-IVA-P4, .cls-5-IVA-P4 {\n        fill: #fff;\n      }\n\n      .cls-9-IVA-P4 {\n        fill: #3a414a;\n      }\n\n      .cls-5-IVA-P4 {\n        stroke-width: 2px;\n      }\n\n      .cls-10-IVA-P4 {\n        fill: #e81313;\n      }\n\n      .cls-6-IVA-P4 {\n        fill: none;\n      }\n\n      .cls-12-IVA-P4 {\n        fill: url(#linear-gradient-IVA-P4);\n        stroke: #1071e5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-IVA-P4",
    x1: 623.6,
    y1: -278.88,
    x2: 623.6,
    y2: -377.55,
    gradientTransform: "translate(-373.56 49.65) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-IVA-P4",
    d: "m79.33,7c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H85.32c-3.31,0-6-2.69-6-6h0V7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-9-IVA-P4",
    d: "m157.3,22.42c5.5,0,8.35,3.12,8.35,8.56,0,4.89-2.38,7.94-6.79,8.56.48,2.04,2.04,3.26,4.69,2.72v1.56c-3.73,1.09-6.45-1.02-6.99-4.14-4.96-.41-7.6-3.46-7.6-8.69s2.85-8.56,8.35-8.56Zm0,15.41c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-9-IVA-P4",
    d: "m172.51,39.73c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-9-IVA-P4",
    d: "m189.96,37.02c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-9-IVA-P4",
    d: "m201.71,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-9-IVA-P4",
    d: "m206.06,36.27c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-9-IVA-P4",
    d: "m215.63,26.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-9-IVA-P4",
    d: "m230.16,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-9-IVA-P4",
    d: "m232.13,39.46v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-9-IVA-P4",
    d: "m248.02,26.56l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-9-IVA-P4",
    d: "m256.51,23.78v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-9-IVA-P4",
    d: "m268.18,26.29c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-9-IVA-P4",
    d: "m281.15,39.46h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m292.83,26.29c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-9-IVA-P4",
    d: "m307.57,26.29c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "cls-9-IVA-P4",
    d: "m317.21,36.27c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-9-IVA-P4",
    d: "m326.78,26.29c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-3",
    "data-name": "u",
    className: "cls-9-IVA-P4",
    d: "m341.31,28.4c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "cls-9-IVA-P4",
    d: "m353.81,26.56l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u-4",
    "data-name": "u",
    className: "cls-9-IVA-P4",
    d: "m135.85,57.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-3",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m142.98,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    className: "cls-9-IVA-P4",
    d: "m157.1,68.8h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-2",
    "data-name": "z",
    className: "cls-9-IVA-P4",
    d: "m163.62,53.11v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-4",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m174.14,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-9-IVA-P4",
    d: "m194.92,68.8h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-9-IVA-P4",
    d: "m207.68,59.09c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-9-IVA-P4",
    d: "m225.34,55.62c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-3",
    "data-name": "y",
    className: "cls-9-IVA-P4",
    d: "m243.27,55.9l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "F-2",
    "data-name": "F",
    className: "cls-9-IVA-P4",
    d: "m257.93,55.62c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-5",
    "data-name": "u",
    className: "cls-9-IVA-P4",
    d: "m271.44,57.73c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-2",
    "data-name": "t",
    className: "cls-9-IVA-P4",
    d: "m281.36,66.35c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-3",
    "data-name": "A",
    className: "cls-9-IVA-P4",
    d: "m293.31,55.62c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-9-IVA-P4",
    d: "m304.72,55.62c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "cls-9-IVA-P4",
    d: "m323.32,65.6c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-5",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m332.89,55.62c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-3",
    "data-name": "t",
    className: "cls-9-IVA-P4",
    d: "m349.26,66.35c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-9-IVA-P4",
    d: "m367.52,57.32c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m575.34,48.69l1,.23.93.4.87.53.78.66.66.77.53.88.4.95.24,1,.08,1v14.76h-1v-14.72l-.07-.88-.2-.84-.33-.8-.45-.73-.56-.66-.65-.56-.73-.44-.8-.33-.84-.2-.88-.07h-19.72v-1h19.76l.98.05Zm-152.25.92v-1h62.36v1h-62.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-IVA-P4",
    d: "m423.1,49.61h-.5v-1h.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m423.13,49.63h-.57v-1.05h.57v1.05Zm-.52-1v.95h.48v-.95h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-IVA-P4",
    d: "m580.32,84.62l-4.63-14.26h9.26l-4.63,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m580.32,86.25l-5.32-16.4h10.64l-5.32,16.4Zm-3.95-15.4l3.95,12.16,3.95-12.15h-7.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-7-IVA-P4",
    d: "m501.76,42.18c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-7-IVA-P4",
    d: "m515.62,50.74c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-7-IVA-P4",
    d: "m524.44,53.79c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-7-IVA-P4",
    d: "m526.41,38.79v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-7-IVA-P4",
    d: "m540.67,43.81c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-2",
    "data-name": "J",
    className: "cls-7-IVA-P4",
    d: "m553.57,50.74c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12-IVA-P4",
    d: "m152.03,334.53c0-3.31,2.69-6,6-6h184.02c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-184.02c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-8-IVA-P4",
    d: "m190.75,371.32c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-8-IVA-P4",
    d: "m208.13,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-2",
    "data-name": "O",
    className: "cls-8-IVA-P4",
    d: "m221.71,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-8-IVA-P4",
    d: "m231.15,366.84c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84Zm3.53,8.22c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-8-IVA-P4",
    d: "m253.56,373.02c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-8-IVA-P4",
    d: "m269.72,381.37c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-8-IVA-P4",
    d: "m283.57,374.31c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-3",
    "data-name": "O",
    className: "cls-8-IVA-P4",
    d: "m300.41,380.42c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-8-IVA-P4",
    d: "m320.58,371.32c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-IVA-P4",
    d: "m79.33,173.15c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v86.68c0,3.31-2.69,6-6,6H85.32c-3.31,0-6-2.69-6-6v-86.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-9-IVA-P4",
    d: "m166.94,216c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-9-IVA-P4",
    d: "m176.59,209.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-2",
    "data-name": "G",
    className: "cls-9-IVA-P4",
    d: "m188.13,209.14c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-4",
    "data-name": "t",
    className: "cls-9-IVA-P4",
    d: "m205.51,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "cls-9-IVA-P4",
    d: "m213.52,219.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-6",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m223.1,209.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-9-IVA-P4",
    d: "m243.47,209.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-9-IVA-P4",
    d: "m257.12,206.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "H-2",
    "data-name": "H",
    className: "cls-9-IVA-P4",
    d: "m278.1,210.84c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-5",
    "data-name": "t",
    className: "cls-9-IVA-P4",
    d: "m293.72,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "cls-9-IVA-P4",
    d: "m301.73,219.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-7",
    "data-name": "w",
    className: "cls-9-IVA-P4",
    d: "m311.3,209.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-6",
    "data-name": "u",
    className: "cls-9-IVA-P4",
    d: "m325.83,211.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-3",
    "data-name": "z",
    className: "cls-9-IVA-P4",
    d: "m327.8,206.63v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-6",
    "data-name": "t",
    className: "cls-9-IVA-P4",
    d: "m341.11,219.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-9-IVA-P4",
    d: "m346.75,222.31v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m485.32,217h-62.22v-1h62.22v1Zm95.5-6.5l-.08,1-.24,1-.4.95-.52.87-.66.77-.78.66-.87.54-.94.4-1,.23-1,.08h-19.9v-1h19.87l.88-.08.84-.2.8-.33.73-.45.66-.57.57-.65.45-.74.33-.8.2-.83.07-.88v-14.42h1v14.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-IVA-P4",
    d: "m423.1,217h-.5v-1h.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m423.13,217.02h-.57v-1.05h.57v1.05Zm-.52-1v.95h.48v-.95h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-IVA-P4",
    d: "m584.96,195.53h-9.27l4.62-14.26,4.65,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m585.64,196.03h-10.64l5.32-16.38,5.32,16.38Zm-9.27-1h7.9l-3.95-12.14-3.95,12.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    "data-name": "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-2",
    "data-name": "I",
    className: "cls-7-IVA-P4",
    d: "m501.62,209.57c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-3",
    "data-name": "J",
    className: "cls-7-IVA-P4",
    d: "m515.47,218.12c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-2",
    "data-name": "K",
    className: "cls-7-IVA-P4",
    d: "m524.3,221.18c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "cls-7-IVA-P4",
    d: "m526.27,206.17v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-7-IVA-P4",
    d: "m540.53,211.2c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-4",
    "data-name": "J",
    className: "cls-7-IVA-P4",
    d: "m553.43,218.12c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-IVA-P4",
    d: "m250.46,267.33l-.3,44.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m250.96,267.35h-1v-.52h1v.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-IVA-P4",
    d: "m250.05,326.41l-4.53-14.3,9.27.07-4.74,14.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11-IVA-P4",
    d: "m397.65,92.25c0-3.31,2.69-6,6-6h353.34c3.31,0,6,2.69,6,6h0v81.4c0,3.31-2.69,6-6,6h-353.35c-3.31,0-6-2.69-6-6v-81.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-9-IVA-P4",
    d: "m520.87,124.69c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-9-IVA-P4",
    d: "m538.25,133.79c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "cls-9-IVA-P4",
    d: "m551.83,133.79c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-9-IVA-P4",
    d: "m561.27,120.21c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84Zm3.53,8.22c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-9-IVA-P4",
    d: "m583.68,126.39c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-9-IVA-P4",
    d: "m599.84,134.74c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-9-IVA-P4",
    d: "m613.69,127.68c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-3",
    "data-name": "Y",
    className: "cls-9-IVA-P4",
    d: "m630.53,133.79c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-9-IVA-P4",
    d: "m647.78,131.55c0-3.12-3.73-3.73-4.96-1.83h-3.26l.61-9.51h10.12v2.51h-7.06l-.27,4.28c2.99-2.58,9.03-.27,8.28,4.48.75,6.99-11.48,7.94-12.15,1.36l3.33-.27c.34,1.22,1.02,2.04,2.65,2.04,1.77,0,2.72-1.22,2.72-3.06"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-IVA-P4",
    d: "m250.46,101.17v48.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-IVA-P4",
    d: "m250.96,101.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-IVA-P4",
    d: "m250.46,164.55l-4.63-14.27h9.27l-4.64,14.27Z"
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#popup_flight_travlDil16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-IVA-P4",
    d: "m4.45,200.25h63.02v33.03H4.45v-33.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-IVA-P4",
    d: "m71.65,201.98L4.09,236.03l-2.27-4.48,67.56-34.05,2.27,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-IVA-P4",
    d: "m70.55,199.97L2.99,234.01l-.68-1.32,67.57-34.04.67,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-IVA-P4",
    d: "m68.45,236.03L1.17,201.43l2.3-4.47,67.27,34.62-2.29,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-IVA-P4",
    d: "m42.7,221.27L1.17,199.9l.62-1.2,41.5,21.37-.59,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-IVA-P4",
    d: "m69.5,233.55l-24.25-12.46.65-1.26,24.24,12.47-.64,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-IVA-P4",
    d: "m2.3,212.27h67.84v9H2.3v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-IVA-P4",
    d: "m40.46,198.58v35.58h-9v-35.57h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-IVA-P4",
    d: "m2.3,213.71h67.84v6.12H2.3v-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-IVA-P4",
    d: "m39.02,198.58v34.7h-6.12v-34.7h6.12Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 0.06,
    y: 27.02,
    width: 2.88,
    height: 37.32,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 1.91,
    y: 24.02,
    width: 70.85,
    height: 4.07,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 66.8,
    y: 25.8,
    width: 3.55,
    height: 38.55,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    y: 196.3,
    width: 3.9,
    height: 39.21,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 67.87,
    y: 197.24,
    width: 4.59,
    height: 38.46,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 1.17,
    y: 196.96,
    width: 69.52,
    height: 4.15,
    style: {
      fill: "#ebf5fe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-IVA-P4",
    x: 2.31,
    y: 233.28,
    width: 68.38,
    height: 4.07,
    style: {
      fill: "#ebf5fe"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvaPhase4);
export default __webpack_public_path__ + "static/media/IVA_Phase_4.ed54a25da58371aa4042bd53fa7739de.svg";
export { ForwardRef as ReactComponent };